<div class="progress-bar-wrapper">
    Download em curso
    <ngb-progressbar type="info" [value]="progress" [striped]="true" [showValue]="true">
    </ngb-progressbar>
    
</div>
